var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "credit-card_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60.75 9.33v45.34H3.25V9.33zM7.25 50.67h49.5V13.33H7.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M49.023 39.727v4h-9.728v-4zM5.25 20.047h53.5v9.728H5.25z"
  })));
};
export { SvgCreditCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNjAuNzUgOS4zMjk1OVY1NC42NzA0SDMuMjVWOS4zMjk1OUg2MC43NVpNNy4yNSA1MC42NzA0SDU2Ljc1VjEzLjMyOTZINy4yNVY1MC42NzA0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZD0iTTQ5LjAyMyAzOS43Mjc0VjQzLjcyNzRIMzkuMjk1NVYzOS43Mjc0SDQ5LjAyM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGQ9Ik01LjI1IDIwLjA0NzJINTguNzVWMjkuNzc0Nkg1LjI1VjIwLjA0NzJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";